// "Walk up to something and press F" interactions. The design (a registry of
// interactables, the nearest one in range gets focus and shows a prompt)
// follows Kinema's InteractionManager (https://github.com/2600th/Kinema, MIT,
// © 2026 Pranshul Chandhok); this version needs no physics engine.
export interface Interactable {
  id: string;
  /** Current position (may move, e.g. a parked car that was driven). */
  where(): { x: number; z: number };
  range: number;
  label(): string;
  act(): void;
  enabled?(): boolean;
}

export function interactions() {
  const items: Interactable[] = [];
  let focused: Interactable | null = null;
  return {
    add(item: Interactable) {
      items.push(item);
    },
    /** Nearest enabled interactable within range of (x, z), or null. */
    focus(x: number, z: number) {
      let best: Interactable | null = null,
        bestD = Infinity;
      for (const it of items) {
        if (it.enabled && !it.enabled()) continue;
        const p = it.where(), d = Math.hypot(p.x - x, p.z - z);
        if (d < it.range && d < bestD) (best = it), (bestD = d);
      }
      focused = best;
      return best;
    },
    get focused() {
      return focused;
    },
  };
}
